import { defineMessages } from 'react-intl'

export default defineMessages({
  des: {
    id: 'components.PCIPrompt.des',
    defaultMessage: 'PayBy cashiers use industry-standard encryption to protect your confidentiaility of cards.',
    description: 'des'
  },
})
